import React from 'react';
import moment from 'moment';

import './styles.less';

const DateDivider = ({ date }: { date: Date }) => {
  return (
    <div className="date-divider">
      <span className="date-divider-content">{moment(date).format('MMMM D')}</span>
    </div>
  );
};

export default DateDivider;
